// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Hdze","image":"Header_image__238vu","name":"Header_name__2EG_c","info":"Header_info__3-hNV","infoRow":"Header_infoRow__3jXSK"};